var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHighIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.298304 6.65685L6.77983 0.292893C7.17757 -0.0976299 7.82243 -0.0976299 8.22017 0.292893L14.7017 6.65685C15.0994 7.04738 15.0994 7.68054 14.7017 8.07107C14.304 8.46159 13.6591 8.46159 13.2614 8.07107L8.51847 3.41421L8.51847 16L6.48153 16L6.48153 3.41421L1.73864 8.07107C1.3409 8.46159 0.696043 8.46159 0.298304 8.07107C-0.0994351 7.68054 -0.0994351 7.04738 0.298304 6.65685Z",
    fill: "#56C662"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighIcon);
export default __webpack_public_path__ + "static/media/highIcon.92663f8267c06d3b8c83831c8fd1d24c.svg";
export { ForwardRef as ReactComponent };